import tenantUtils from '@utils';
import { NetworkService } from '../../../../services/networkService';
import { TIME_DATE_FORMAT } from '../../../../constants/formats';
import { getTimeDateString } from '../../../../utility/date';


export const getTasksTypes = async () => {
  const response = await NetworkService.get(`/api/task_types?search_class=Lead`);
  if (response?.error) {
    return response; 
  } else {
    return response.data; 
  }
};
